<template>
  <w-dialog closeFree width="564px" title="查看全部" top="calc(50vh - 200px)" v-model="visible" class="pop-dialog" @ok="visible=false">
    <div class="user-content">
      <div class="item-user" v-for="(user, index) in list" :key="index">
        <div class="user-photo">
          <img src="~@/assets/def_avatar_84px.png" class="avatar" alt="">
          <!-- <i class="close el-icon-close" v-if="!user.disabled && user.isEdit" @click="delUser"></i> -->
        </div>
        <div class="name-con">
          <div class="serial">{{ user.serial }}</div>
          <div class="name ellipsis">{{ user.name || user.reallyName }}</div>
        </div>
      </div>
    </div>
  </w-dialog>
</template>

<script>
export default {
  name: "popUserMore",
  components: {},
  data() {
    return {
      visible: false,
      list:[]
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    show(list) {
      this.visible = true
      this.list = list
    },
    delUser(){
      this.$emit('delUser')
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-dialog {
  .user-content {
    max-height: 285px;
    overflow-y: auto;
    display: inline-flex;
    flex-wrap: wrap;
    width: 512px;
    margin: 0  0  20px 0;
    .item-user {
      width: 62px;
      margin-bottom: 10px;
    }

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      display: block;
    }
    .user-photo {
      position: relative;
    }
    .close{
        position: absolute;
        top: 1px;
        left: 31px;
        color: #fff;
        cursor: pointer;
        border-radius: 50%;
        background: #C5C9C9;
        padding: 1px;
        line-height: 1;
      }
    .name-con {
      font-size: 12px;
      color: #939696;
      line-height: 17px;
    }
  }
}

.pop-dialog /deep/ {
  .el-dialog__header {
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
  }

  .el-dialog__body {
    padding: 16px 20px 0 32px;
  }

  .el-form-item {
    margin-bottom: 26px;
  }

  .el-dialog__footer {
    padding: 6px 0 16px;
  }
}
</style>
